import { NavLink } from "../../NavLink";
import { useAddGerichtMutation, useAddGerichtZutatMutation, useGetGerichtQuery, useListGerichteQuery, useRemoveGerichtMutation, useRemoveGerichtZutatMutation, useSetGerichtNameMutation } from "./gerichteConnector";
import { Einheit } from "../../utils/Einheit";
import { getFieldValue } from "../../utils/getFieldValue";
import classNames from "classnames";
import { Zutat } from '../zutaten/zutatenConnector';

import "./Gerichte.css"
import React from "react";
import { Menge } from "../../utils/Menge";
import { MainContent } from "../../utils/MainContent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Mengenangabe } from "../../utils/Mengenangabe";
import { AddZutatComponent } from "./AddZutatComponent";
import { Route, useLocation, useParams } from "wouter";


export function GerichtComponent() {
    const [addGerichtZutat] = useAddGerichtZutatMutation();
    const [removeGerichtZutat] = useRemoveGerichtZutatMutation();
    const [setGerichtName] = useSetGerichtNameMutation();
    const [removeGericht] = useRemoveGerichtMutation();
    const [, navigate] = useLocation();

    const params = useParams();

    const { data, error, isLoading } = useGetGerichtQuery(parseInt(params.id!));
    if (data === undefined) {
        if (error) {
            return <>ERROR: {JSON.stringify(error)}</>
        }
        return <>Loading...</>
    }
    const { name, zutaten, id } = data;

    return <div className="gericht-details">
        <FontAwesomeIcon className="remove-button" icon={faTrash}
            onClick={() => {
                if (window.confirm(`Sicher, dass das Gericht ${name} gelöscht werden soll?`)) {
                    navigate("/gerichte")
                    removeGericht(id)
                }
            }}
        />

        <h2 contentEditable suppressContentEditableWarning
            onBlur={(e) => {
                const editedName = e.currentTarget.innerText.trim();
                if (editedName !== name) {
                    setGerichtName({ gerichtId: id, name: editedName });
                }
            }}
            onKeyDown={e => {
                if (e.key === "Enter") e.currentTarget.blur();
            }}
        >{name}</h2>


        <ul className="zutaten-liste">
            {zutaten.map(zutat => <li key={zutat.id}>
                <Menge menge={zutat.menge} einheit={zutat.einheit} />{" "}
                <span className="zutat-name">{zutat.zutat.name}</span>
                <FontAwesomeIcon className="remove-button" icon={faXmark}
                    onClick={() => removeGerichtZutat({ gerichtId: id, zutatId: zutat.zutat.id })}
                />
            </li>)}
        </ul>
        <AddZutatComponent onConfirm={(zutatId, menge) => addGerichtZutat({ gerichtId: id, zutatId, ...menge })} />
    </div>
}

export type ZutatOptionValue =
    | {
        type: "zutat",
        menge: number,
        einheit: Einheit,
        zutat: Zutat
    }
    | {
        type: "neueZutat",
        menge: number,
        einheit: Einheit,
        zutatName: string
    }

export function parseZutatInput(input: string): { zutatName: string } & Mengenangabe {
    const inputTrimmed = input.trim();
    const mengenRegex = /(?<menge>\d+)\s*(?<einheit>g|ml|kg|l|el|tl|x|)(?:$|\W)/i;
    const einheitenTransforms: { [key in string]: (menge: number) => Mengenangabe } = {
        "kg": menge => ({ menge: menge * 1000, einheit: "g" }),
        "l": menge => ({ menge: menge * 1000, einheit: "ml" }),
        "x": menge => ({ menge, einheit: "stueck" }),
        "": menge => ({ menge, einheit: "stueck" }),
        "el": menge => ({ menge, einheit: "essloeffel" }),
        "tl": menge => ({ menge, einheit: "teeloeffel" }),
    }
    const match = mengenRegex.exec(inputTrimmed)?.groups;
    if (match) {
        const menge = parseInt(match.menge);
        const einheit = match.einheit.toLowerCase() as Einheit;
        const transform = einheitenTransforms[einheit];
        const mengenangabe = transform ? transform(menge) : { menge, einheit };
        const zutatName = inputTrimmed.replace(mengenRegex, "").trim();
        return { ...mengenangabe, zutatName }
    }
    return { menge: 1, einheit: "stueck", zutatName: inputTrimmed };
}

export function GerichtListRouteComponent() {
    const { data, error } = useListGerichteQuery();
    const [addGericht, addGerichtError] = useAddGerichtMutation();
    const [, navigate] = useLocation();

    if (data === undefined) {
        if (error) {
            return <>ERROR: {JSON.stringify(error)}</>
        }
        return <>Loading...</>
    }
    return <>
        <ul className="gerichte-liste">
            {data.map(({ id, name, hatZutaten }) =>
                <li key={id} className={classNames("gericht-eintrag", { hatZutaten })}>
                    <NavLink to={`/gerichte/${id}`}> {name}</NavLink>
                </li>)}
            <li>
                <form onSubmit={async e => {
                    e.preventDefault();
                    const result = await addGericht(getFieldValue(e, "name"));
                    if (result.data !== undefined) {
                        navigate(`/gerichte/${result.data.id}`)
                    }
                }}>
                    <input id="name" type="text" />
                    <input type="submit" value="Neues Gericht erstellen" />
                    {addGerichtError.isError && JSON.stringify(addGerichtError.error)}
                </form>
            </li>
        </ul>
        <MainContent backLink="/gerichte" >
            <Route path="/gerichte/:id">
                <GerichtComponent />
            </Route>
        </MainContent>
    </>
}